<template>
    <CCard class="mb-0 h-100">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title text-center">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="view_tab">
                <!-- Subscriptions -->
                <CTab :title="$t('subscriptions')">
                    <!-- Subscription -->
                    <CContainer class="section px-5" fluid>
                        <CRow class="my-4 px-3" alignHorizontal="between">
                                <h3>{{ $t('summary')}}</h3>
                                <CDropdown
                                    color="primary"
                                    :toggler-text="$t(text_dropdown)" 
                                    class="lg_dropdown--simple"
                                >
                                    <CDropdownItem 
                                        v-for="(item,key) in list_coins" :key="key"
                                        @click="currency_active = key"
                                    >
                                        {{ $t(`${item.text}_(${item.symbol})`) }}
                                    </CDropdownItem>
                                    
                                </CDropdown>
                        </CRow>
                        <CRow alignHorizontal="center">
                            <CCol sm="12" md="8">
                                <CCardGroup :deck="true">
                                    <!-- Free plan -->
                                    <CCard class="free_plan">
                                        <CCardBody>
                                            <CContainer fluid>
                                                <div class="d-flex">
                                                    <span><CIcon :content="$options.icons.cilInfo" /></span><h4 class="free_plan__title">{{ $t('free_plan') }}</h4>
                                                </div>
                                                <p class="free_plan__description">
                                                    {{ 
                                                        $t('the_plan_ends_on') + ' ' + formatDateUnixTimestamp(subscription.current_period_end)
                                                    }}
                                                </p>

                                                <CRow>
                                                    <CCol sm="4">
                                                        {{ $t('auto_renew') }}
                                                    </CCol>
                                                    <CCol sm="3">
                                                        <CSwitch
                                                            color="primary"
                                                            shape="pill"
                                                            :checked.sync="subscription.cancel_at_period_end"
                                                            @update:checked="switchAutoRenew(subscription)"
                                                        />
                                                    </CCol>
                                                </CRow>

                                                <!-- price -->
                                                <div class="free_plan__price price">
                                                    <span class="price__amount">0,00</span><span class="price__currency">{{ currency }}</span> / <span class="price__pedriod_time"> {{$t('_month')}} </span>
                                                </div>

                                                
                                            </CContainer>
                                        </CCardBody>
                                    </CCard>
                                    <!-- Details free plan -->
                                    <CCard class="details_free_plan">
                                        <CCardBody>
                                            <div class="d-flex">
                                                <h4 class="details_free_plan__title">{{ $t('use') }}</h4>
                                            </div>
                                            <p class="details_free_plan__subtitle">{{ $t('account_limits') }}</p>
                                            <div class="details_free_plan__bar" ></div>
                                            <ul class="details_free_plan__features">
                                                <li class="features_item">
                                                    <div class="features_item--left">
                                                        {{ $t('databases')}}
                                                    </div>
                                                    <div class="features_item--right">
                                                        1
                                                    </div>
                                                </li>
                                                <li class="features_item">
                                                    <div class="features_item--left">
                                                        {{ $t('recruitment_campaigns')}}
                                                    </div>
                                                    <div class="features_item--right">
                                                        1
                                                    </div>
                                                </li>
                                                <li class="features_item">
                                                    <div class="features_item--left">
                                                        {{ $t('delivery_campaigns')}}
                                                    </div>
                                                    <div class="features_item--right">
                                                        1
                                                    </div>
                                                </li>
                                                <li class="features_item">
                                                    <div class="features_item--left">
                                                        {{ $t('creativities')}}
                                                    </div>
                                                    <div class="features_item--right">
                                                        {{ $t('limited') }}
                                                    </div>
                                                </li>
                                                <li class="features_item">
                                                    <div class="features_item--left">
                                                        {{ $t('daily_contacts')}}
                                                    </div>
                                                    <div class="features_item--right">
                                                        100
                                                    </div>
                                                </li>
                                            </ul>

                                            <CLink class="details_free_plan__link"> {{ $t('select_monthly_plan') }}</CLink>
                                        </CCardBody>
                                    </CCard>
                                </CCardGroup>
                            </CCol>
                            <CCol sm="12" md="4">
                                <!-- Professional plan -->
                                <CCard class="professional_plan">
                                    <CCardBody class="professional_plan__container">
                                        <h4 class="professional_plan__title">{{ $t('professional_plan') }}</h4>
                                        <p class="professional_plan__description">{{ $t('to_help_you_expand_your_business') }}</p>

                                        <div class="professional_plan__price price">
                                            <div class="d-flex justify-content-center">
                                                <span class="price__text">{{ $t('from') }}</span>
                                            </div>
                                            <div>
                                                <span class="price__amount">{{ amount }}</span><span class="price__currency">{{ currency }}</span> / <span class="price__pedriod_time"> {{$t('_month')}} </span>
                                            </div>
                                        </div>
                                        <CButton class="professional_plan__button" :block="true"> {{ $t('start')}} </CButton>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>
                    </CContainer>
                </CTab>
                

                <!-- Invoices -->
                <CTab :title="$t('invoices')">
                    <!-- Tab profile-->
                    <CContainer class="section" fluid>
                        <CRow class="border-bottom">
                            <CCol md="10">
                                <h2 class="section__title my-4">{{ $t('invoices') }}</h2>
                            </CCol>
                        </CRow>
                        <CRow alignHorizontal="center" alignVertical="center" class="mt-4">
                            <CCol md="12">
                                <CContainer class="personal-info" fluid>
                                    <!-- Table invoices -->
                                    <CDataTable
                                        :addTableClasses="['table--sm']"
                                        :items="tables.invoices.items"
                                        :fields="traslateLabels(tables.invoices.fields)"
                                        :items-per-page="tables.invoices.rows"
                                        :loading="tables.invoices.loading"
                                        hover
                                        striped
                                    >
                                        <template #id="{index}">
                                            <td>
                                                {{ index + 1 }}
                                            </td>
                                        </template>
                                        <template #hosted_invoice_url="{ item }">
                                            <td>
                                                <a 
                                                    :href="item.hosted_invoice_url"
                                                    target="_blank"
                                                >
                                                {{ $t('invoice') }}
                                                </a>
                                            </td>
                                        </template>
                                        <template #created="{item}">
                                            <td>
                                                {{ formatDateUnixTimestamp(item.created) }}
                                            </td>
                                        </template>
                                        <template #period_start="{item}">
                                            <td>
                                                {{ formatDateUnixTimestamp(item.period_start) }}
                                            </td>
                                        </template>
                                        <template #period_end="{item}">
                                            <td>
                                                {{ formatDateUnixTimestamp(item.period_end) }}
                                            </td>
                                        </template>
                                    </CDataTable>
                                </CContainer>
                            </CCol>
                        </CRow>
                        
                    </CContainer>
                </CTab>

                <!-- Payment method -->
                <CTab :title="$t('payment_method')">
                    <!-- Tab profile-->
                    <CContainer class="section" fluid>
                        <CRow class="border-bottom">
                            <CCol md="10">
                                <h2 class="section__title my-4">{{ $t('payment_method') }}</h2>
                            </CCol>
                            <CCol md="2">
                                <CButton 
                                    color="primary"
                                    class="button my-4 shadow"
                                    size="sm"
                                    @click="savePaymentMethodDefault()"
                                >
                                    
                                    <span class="button__icon"><CIcon size="sm" :content="$options.icons.cilSave" /></span>
                                    <span class="button__text">{{$t('save')}}</span> 
                                    
                                </CButton>
                            </CCol>
                        </CRow>
                        <CRow alignHorizontal="center" alignVertical="center" class="mt-4">
                            <CCol md="5">
                                <CCard>
                                    <CCardBody>
                                        <CInput
                                            :lazy="false"
                                            :value.sync="$v.forms.payment_method.billing_name.$model"
                                            :isValid="checkIfFormValid({ 
                                                form_name:'payment_method',
                                                field_name:'billing_name' 
                                            })"
                                            :placeholder="`${$t('billing_name')}`"
                                            :invalidFeedback="$t('billing_name_is_required')"
                                        ></CInput>
                                        <div class="group card-element mx-3">
                                            <div class="row">
                                                <div class="col-sm-12 p-0">
                                                    <StripeElement 
                                                        :instance_stripe_elements="stripe.elements"
                                                        element_type='cardNumber'
                                                        :value.sync="$v.forms.payment_method.card_number.$model"
                                                        :isValid="checkIfFormValid({ 
                                                            form_name:'payment_method',
                                                            field_name:'card_number' 
                                                        })"
                                                    />
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-7 p-0">
                                                    <StripeElement 
                                                        :instance_stripe_elements="stripe.elements"
                                                        element_type='cardExpiry'
                                                        :value.sync="$v.forms.payment_method.card_expiry.$model"
                                                        :isValid="checkIfFormValid({ 
                                                            form_name:'payment_method',
                                                            field_name:'card_expiry' 
                                                        })"
                                                    />
                                                </div>
                                                <div class="col-sm-5 p-0">
                                                    <StripeElement 
                                                        :instance_stripe_elements="stripe.elements"
                                                        element_type='cardCvc'
                                                        :value.sync="$v.forms.payment_method.card_cvc.$model"
                                                        :isValid="checkIfFormValid({ 
                                                            form_name:'payment_method',
                                                            field_name:'card_cvc' 
                                                        })"
                                                    />
                                                </div>
                                            </div>
                                        </div> 
                                    </CCardBody>
                                </CCard>
                                
                            </CCol>
                        </CRow>
                        
                    </CContainer>
                </CTab>
            </CTabs>
            
            
        </CCardBody>
    </CCard>
    
    
</template>

<script>

import StripeElement from "~/components/StripeElement";

import { mapGetters } from 'vuex';
import pageMixin from '~/mixins/page.js';
import dateMixin from '~/mixins/date.js';

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { cilSave } from '@coreui/icons';

export default {
    name: "BillingDetailsPage",

    middleware: ['auth','page', 'import-stripe'],

    mixins: [ pageMixin, dateMixin, validationMixin ],

    icons:{
        cilSave
    },

    components:{
        StripeElement
    },

    data() {
        return {
            tables:{    
                invoices:{
                    fields:[
                        {
                            key: "id",
                            label: "#",
                        },
                        {
                            key:"hosted_invoice_url",
                            label:"invoice"
                        },
                        {
                            key: "currency",
                            label: "currency",
                        },
                        {
                            key: "created",
                            label: "created",
                        },
                        {
                            key: "period_end",
                            label: "period_end",
                        },
                        {
                            key: "period_start",
                            label: "period_start",
                        },
                        {
                            key: "status",
                            label: "status",
                        },
                        {
                            key: "total",
                            label: "total",
                        },
                    ],
                    items:[],
                    order:"asc",
                    rows:5,
                    page:1,
                    total_pages:1,
                    loading:false

                }
            },
            subscription:{

            },
            forms:{
                payment_method:{
                    billing_name:null,
                    card_number:null,
                    card_expiry:null,
                    card_cvc:null,
                }
            },
            stripe:{
                instance:null,
                elements:null
            },
            list_coins:{
                dollar:{
                    symbol:'$',
                    text:'dollar'
                },
                euro:{
                    symbol:'€',
                    text:'euro'
                }
            },
            list_prices:{
                dollar: "15,00",
                euro: "19,00"
            },
            currency_active:'euro',
        }
    },
    computed:{
        ...mapGetters({
            user:"auth/user",
            storeFrom:"filter/from",
            storeTo:"filter/to"
        }),
        view_tab:function(){
            return parseInt(this.$route.query.view_tab)  || 0;
        },
        text_dropdown:function(){
            return `${this.list_coins[this.currency_active].text}_(${this.list_coins[this.currency_active].symbol})`
        },

        currency:function(){
            return this.list_coins[this.currency_active].symbol;
        },
        amount:function(){
            return this.list_prices[this.currency_active];
        }
    },

    validations: {
        forms: {
            payment_method:{
                billing_name:{
                    required
                },
                card_number:{
                    required
                },
                card_expiry:{
                    required
                },
                card_cvc:{
                    required
                },
            }
            
        },
    },
    methods: {
        getBadge (status) {
            switch (status) {
                case 'active': return 'success'
                case 'inactive': return 'secondary'
                case 'canceled': return 'warning'
                case 'trialing': return 'primary'
                case 'banned': return 'danger'
                default: 'primary'
            }
        },

        async createPaymentMethod(billing_name, card) {
            return this.stripe.instance.createPaymentMethod({
                type: 'card',
                card: card,
                billing_details: {
                    name: billing_name
                },
            }).then((result) => {
                if (result.error) {
                    this.displayError(result);
                    return null;
                } else {
                    return result.paymentMethod;
                }
            });
        },

        async savePaymentMethodDefault(){

            let form_response = await this.sendForm({
                url:'/customer.api/PaymentMethodDefault',
                method:'PUT',
                form_name:'payment_method',
                formatData:async ( form_data )=>{
                    let payment_method = await this.createPaymentMethod(form_data.billing_name, form_data.card_number);
                    form_data.payment_method_id = payment_method.id;
                    delete form_data.card_number;
                    delete form_data.card_expiry;
                    delete form_data.card_cvc;
                    return form_data;
                } 
            });

            if(form_response.status){
                this.showMessageSuccess({ 
                    body: data.message
                });
            }
        },
        
        updatePagination(table_name, newValue){
            this.tables[table_name].page = newValue;
            this.updateData({
                from:this.storeFrom,
                to:this.storeTo
            });
        },

        async switchAutoRenew(subscription){
            let response = await this.sendData({
                url:'/customer.api/subscription/cancel',
                method:'POST',
                data:{
                    cancel_at_period_end:!subscription.plan.cancel_at_period_end,
                    subscriptionId:subscription.id
                }
            });

            console.log(response);

            this.showMessageSuccess({ 
                body:response.message
            })

        },
        async updateSubscription(){
            let subscriptions = await this.loadData({ 
                url: '/customer.api/GetSubscriptions',  
                method: 'GET'
            });
            this.subscription = subscriptions._items[0];
        },
        async updateData() {
            await this.updateTable({ 
                table_name: 'invoices', 
                url: '/customer.api/GetInvoices' , 
                method: 'GET',  
            });
            await this.updateSubscription();
            this.updatePageLoading(false);
        },
    },
    async mounted(){
        await this.updateData();
        
    },
    async created(){
        this.stripe.instance = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
        this.stripe.elements = this.stripe.instance.elements();
    }
    
}
</script>
<style scoped lang="scss">
    .personal-info{
        padding: 0;
        & .c-avatar{
            width: 7em;
            height: auto;
            position: relative;

            & .c-avatar-input{
                position: absolute !important;
                z-index: 1000;
                right: -5px;
                top: -5px;
                & .btn{
                    border-radius: 50px;
                    background-color: white;
                    & .c-avatar-label{
                        margin: 0;
                    }
                }
                
            }
        }

        @media (min-width: 576px) {
            padding: 0 2em;
        }
    }
    

    .free_plan{
        min-height: 24rem;
        & .free_plan__title{
            font-size: 1.2rem;
            font-weight: 700;
            margin-bottom: 1.5rem ;
            margin-left: 2rem;
        }

        & .free_plan__price{
            font-size: 2rem;
            font-weight: 900;
            margin-top: 2rem;
            font-family: Times, "Times New Roman", serif;
            & .price__currency{
                font-size: 1.3rem;
                display: inline-block;
                vertical-align:top;
            }
        }
    }

    .details_free_plan{
        min-height: 24rem;
        & .details_free_plan__title{
            font-size: 1.2rem;
            font-weight: 700;
            margin-bottom: 1.5rem ;
            margin-left: 2rem;
        }

        & .details_free_plan__bar{
            border:  5px solid blue;
            border-radius: 25px ;
        }

        & .details_free_plan__features{
            margin-top: 2rem ;
            margin-bottom: 1.7rem;
            list-style: none;
            padding-left: 0;
            & .features_item{
                color: rgba(128, 128, 128, 0.849);
                margin-bottom: 0.7rem;
                font-size: 0.9rem;
                display: flex;
                justify-content: space-between;
            }
        }

        & .details_free_plan__link{
            font-size: 1rem;
        }

    }

    .professional_plan{
        background-color: #f5f6fe;
        box-shadow: none !important;
        & .professional_plan__container{
            display: flex;
            // justify-content: center;
            align-items: center;
            flex-direction: column;

            & .professional_plan__title{
                color: #1d5be9;
                font-size: 3rem;
                font-family: Times, "Times New Roman", serif;
                font-weight: 900;
                margin-top: 2rem;
                margin-bottom: 2rem;
            }

            & .professional_plan__description{
                color: #8c9db8;
                margin-bottom: 3rem;
            }

            & .professional_plan__price{
                font-size: 2rem;
                font-family: Times, "Times New Roman", serif;
                font-weight: 900;
                margin-top: 2rem;
                & .price__text{
                    font-size: 1rem;
                }
                & .price__currency{
                    font-size: 1.3rem;
                    display: inline-block;
                    vertical-align:top;
                }
            }
        }

        & .professional_plan__button{
            background-color: #1d5be9;
            margin-top: 2rem;
            color: white;
            font-size: 1.3rem;
            padding: 1.3rem 0;
        }
        
    }
    
    
</style>
